import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetAdComplaintConfigFormUseCase extends UseCase {
  constructor({adComplaintConfigFormVOMapper, getCurrentUserService}) {
    super()
    this._adComplaintConfigFormVOMapper = adComplaintConfigFormVOMapper
    this._getCurrentUserService = getCurrentUserService
  }

  @tracer({metric: 'GetAdComplaintConfigFormUseCase#execute'})
  @inlineError
  async execute({complaintTypeId} = {}) {
    const userEntity = await this._getCurrentUserService.execute()

    const configFormVO = this._adComplaintConfigFormVOMapper
      .setParams({
        complaintTypeId,
        userEntity
      })
      .map()

    return configFormVO.toJSON()
  }
}
